module.exports = {"RI23":"Raffles Institution Primary Mathematics World Contest 2023"}


//////////////////
// WEBPACK FOOTER
// ./src/config/heading_US.json
// module id = 332
// module chunks = 0